module.exports = __webpack_public_path__ + "static/media/Center.2da88e1c.jpeg";